<template>
  <v-row wrap>
    <v-col sm="12">
      <v-tabs v-model="currentTab" :background-color="`${theme.primaryColor} lighten-5`">
        <v-tab ripple key="needsReview">Needs Review ({{ needsReviewCount }}) </v-tab>
        <v-tab ripple key="noQaAnalyst">Needs Analyst ({{ needsAnalystCount }}) </v-tab>
        <v-tab data-cy="packLead-publishedTab" ripple key="published">Published ({{ publishedCount }}) </v-tab>

        <v-tab-item eager key="needsReview"
          ><tab-needs-review @noteCount="getNeedsReviewCount"></tab-needs-review
        ></v-tab-item>
        <v-tab-item eager key="noQaAnalyst"
          ><tab-no-qa-analyst @noteCount="getNeedsAnalystCount"></tab-no-qa-analyst
        ></v-tab-item>
        <v-tab-item eager key="published"><tab-published @noteCount="getPublishedCount"></tab-published></v-tab-item>
      </v-tabs>
    </v-col>
  </v-row>
</template>

<script>
import TabNeedsReview from "@/views/dashboard/qa/widgetPackLead/TabNeedsReview";
import TabNoQaAnalyst from "@/views/dashboard/qa/widgetPackLead/TabNoQaAnalyst";
import TabPublished from "@/views/dashboard/qa/widgetPackLead/TabPublished";

export default {
  components: {
    TabNeedsReview,
    TabNoQaAnalyst,
    TabPublished,
  },
  computed: {
    theme() {
      return this.$store.state.session.theme;
    },
  },
  data() {
    return {
      currentTab: null,
      needsReviewCount: 0,
      needsAnalystCount: 0,
      publishedCount: 0,
    };
  },
  methods: {
    getNeedsReviewCount(val) {
      this.needsReviewCount = val;
    },
    getNeedsAnalystCount(val) {
      this.needsAnalystCount = val;
    },
    getPublishedCount(val) {
      this.publishedCount = val;
    },
  },
};
</script>
